import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ProductDetail from '../views/ProductDetail.vue'
import IndexCleanup from '../views/IndexCleanup.vue'

const routes = [
    { path: '/', name: 'Home', component: HomeView },
    { path: '/product/:spuId', name: 'ProductDetail', component: ProductDetail },
    { path: '/index-cleanup', name: 'IndexCleanup', component: IndexCleanup }
]

// 创建 router
const router = createRouter({
    history: createWebHistory(),
    routes
})

// 导出 router
export default router
